import { useEffect, useState } from 'react';
import { apiFetch } from '../api/client';
import { listOnlinePresence } from '../api/students';

/** Returns true when the given student is currently online. Polls every 10 s. */
export function useStudentPresence(studentId: string | undefined): boolean {
  const [online, setOnline] = useState(false);

  useEffect(() => {
    if (!studentId) return;

    let cancelled = false;

    async function poll() {
      try {
        const res = await apiFetch(`/students/${studentId}/presence`);
        if (!cancelled && res.ok) {
          const data: { online: boolean } = await res.json();
          setOnline(data.online);
        }
      } catch {
        // ignore — stay at last known value
      }
    }

    void poll();
    const id = setInterval(() => void poll(), 10_000);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, [studentId]);

  return online;
}

/** Returns the set of online student IDs. Polls /students/presence every 10 s. */
export function useOnlineStudentsSet(): Set<string> {
  const [set, setSet] = useState<Set<string>>(new Set());

  useEffect(() => {
    let cancelled = false;

    async function poll() {
      try {
        const data = await listOnlinePresence();
        if (!cancelled) setSet(new Set(data.ids));
      } catch {
        // ignore
      }
    }

    void poll();
    const id = setInterval(() => void poll(), 10_000);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, []);

  return set;
}
